module.exports = __webpack_public_path__ + "img/xuanzetiankong.1741652d.png";